import { Component, Input } from '@angular/core';
import { IDynamicComponent } from '../../models/dynamic-component-loader/IDynamicComponent.model';



@Component({
  template: `
    <div class="dynamic-component">
        <mat-icon class="material-icons" svgIcon="new-card-not-access"></mat-icon>
        <h2>{{data.title}}</h2>
        <h3>{{data.subTitle}}</h3>
    </div>
  `,
  styles: [`.dynamic-component{ 
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 30px;
        margin-bottom: 10px;
    }
    mat-icon{
        width: 65px !important;
        height: 65px !important;
    }`]
})
export class NoAccessPermissionComponent implements IDynamicComponent {
  @Input() data: any;
}